// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"7050132e","967":"162b05e2"}[chunkId] + ".chunk.js";
};